
<div class="d-flex h-100 w-100 align-items-center justify-content-center">
    
    <div>
        <div class="py-3">:(</div>
        <button (click)="login()" mat-raised-button color="primary">Retry Login</button>
    </div>
</div>